import React, { useEffect, useState } from "react";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";

export default function PaidReferralBy() {
  const [records, setRecords] = useState([]);
  const [statusMessages, setStatusMessages] = useState({});

  const fetchReferralData = async () => {
    try {
      const res = await fetch(AIRTABLE_URL, {
  headers: AIRTABLE_HEADERS
});

      const data = await res.json();

      const filtered = data.records
        .filter((rec) => parseFloat(rec.fields.earning) === 50.0)
        .map((rec) => ({
          id: rec.id,
          referralby: rec.fields.referralby || "N/A",
          phone: rec.fields.phone || "N/A",
          earning: rec.fields.earning || "",
        }));

      setRecords(filtered);
    } catch (err) {
      console.error("Error fetching referral records:", err);
    }
  };

  useEffect(() => {
    fetchReferralData();
  }, []);

  const updateEarning = async (recordId, newValue) => {
    try {
   const res = await fetch(`${AIRTABLE_URL}/${recordId}`, {
  method: "PATCH",
  headers: AIRTABLE_HEADERS,
  body: JSON.stringify({
    fields: {
      earning: newValue,
    },
  }),
});

      const result = await res.json();

      if (result.id) {
        setStatusMessages((prev) => ({
          ...prev,
          [recordId]: "✅ Updated",
        }));
        setTimeout(() => {
          setStatusMessages((prev) => {
            const copy = { ...prev };
            delete copy[recordId];
            return copy;
          });
        }, 3000);
      }
    } catch (err) {
      console.error("❌ Failed to update earning:", err);
      setStatusMessages((prev) => ({
        ...prev,
        [recordId]: "❌ Failed",
      }));
    }
  };

  const handleEarningChange = (index, value) => {
    const updated = [...records];
    updated[index].earning = value;
    setRecords(updated);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Referralby Payment Update</h2>
      {records.length === 0 ? (
        <p>No entries found for referralby payment update.</p>
      ) : (
        <table border="1" cellPadding="10" style={{ width: "100%", marginTop: 20 }}>
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2" }}>
              <th>ReferralBy</th>
              <th>Referred Phone</th>
              <th>Earning (Editable)</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {records.map((rec, index) => (
              <tr key={rec.id}>
                <td>{rec.referralby}</td>
                <td>{rec.phone}</td>
                <td>
                  <input
                    value={rec.earning}
                    onChange={(e) => handleEarningChange(index, e.target.value)}
                    onBlur={() => updateEarning(rec.id, rec.earning)}
                    style={{ width: 100 }}
                  />
                </td>
                <td style={{ color: "green" }}>{statusMessages[rec.id]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
